import { createSlice } from '@reduxjs/toolkit';
import type { RolesInterface } from '../roles/types';

interface UserListState {
  search: string;
  filterByRole: RolesInterface | null;
  filterByStatus: 'all' | 'active' | 'inactive' | '';
  page: number;
}

const initialState: UserListState = {
  search: '',
  filterByRole: null,
  filterByStatus: '',
  page: 1,
};

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    setFilterByRole: (state, action) => {
      state.filterByRole = action.payload;
      state.page = 1;
    },
    setFilterByStatus: (state, action) => {
      state.filterByStatus = action.payload;
      state.page = 1;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    reset: () => {
      return structuredClone(initialState);
    },
  },
});

export const userListActions = userListSlice.actions;
export const userListReducer = userListSlice.reducer;
